import {PaymentSourceStatus} from 'enums';
import {AccountPlanId} from 'types';

export const MIN_USERS_LIMIT = 1;
export const MAX_USERS_LIMIT = 1000;

export const CHARGEBEE_CLIENT_SCRIPT = 'https://js.chargebee.com/v2/chargebee.js';

export const PARTNER_STACK_SCRIPT_PATH = 'https://js.partnerstack.com/v1/';

export const VALID_PAYMENT_SOURCE_STATUSES = [
    PaymentSourceStatus.Expiring,
    PaymentSourceStatus.Valid
];

export const PLANS_WITH_BILLING = [AccountPlanId.Free, AccountPlanId.Pro, AccountPlanId.Enterprise];
export const PLANS_WITH_UPGRADE = [AccountPlanId.Free/*, AccountPlanId.Pro*/];
export const PLANS_WITH_BILLING_PLATFORM_PAYMENT = [AccountPlanId.Pro, AccountPlanId.Enterprise]; // isPlanWithBillingPlatformPayment